import { BrowserRouter } from "react-router-dom";
import { Routes, Route } from "react-router-loading";


import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import './App.css';
// import "./styles/login.css"
// import "./styles/register.css"
// import "./styles/custom.css"

import {
  Header,
  Login,
  // Register,
  Onboarding,
  Dashboard,
  ZoneCreate,
  PublisherListing,
  ZoneListing,
  AdTxtUpload,
  NoPageComponent,
  MediaPlanner,
  MyProfile,
  AdminUserList,
  SiteListingFreewheel,
  SiteListingPubmatic,
  RemoteFeedListing,
  AdvertiserListing,
  ExtendedUserListing,
  CampaignListGam,
  IpListing,
  AppBundleListing,
  CategoryListing,
  PublisherDomainListing,
  Reporting,
  AdminTagList,
  GamAutomationList,
  AdminDomainList,
  SavedReports,
  AdminCheckAdcodesList,
  CTVMediaPlanner,
  AdminCtvCsvUploadList,
} from "./components";


// Ui Routs 
import LoginUI from "./design/login-and-signup/LoginUI.jsx";
import LoginComponents from "./design/login-and-signup/components/LoginComponents.jsx";
import SignupUi from "./design/login-and-signup/SignupUi.jsx";
import OtpUi from "./design/login-and-signup/OtpUi.jsx";
import OnboardingUi from "./design/onboarding/OnboardingUi.jsx";
import OnboardingComponents from "./design/onboarding/components/OnboardindComponents.jsx";
import OnboardingFormUi from "./design/onboarding/OnboardingFormUi.jsx";
import OnboardingMessageUi from "./design/onboarding/OnboardingMessageUi.jsx";
import PubslishersListingUi from "./design/publishers-listing/components/PubslishersListingUi.jsx";
import CreateZoneUi from "./design/zone/CreateZoneUi.jsx";
import Components from "./design/components/Components.jsx";
import ZoneListingUi from "./design/zone/ZoneListingUi.jsx";
import GamUi from "./design/zone/GamUi.jsx";
import AdsTxt from "./design/publishers-listing/components/AdsTxt.jsx";
import LoaderDesign from "./design/components/LoaderDesign.jsx";
import ImportUi from "./design/publishers-listing/ImportUi.jsx";
import ImportZoneUi from "./design/zone/ImportZoneUi.jsx";
import SitesTable from "./design/sites/SitesTable.jsx";
import SitesForm from "./design/sites/SitesForm.jsx";
import SiteCreateZone from "./design/sites/SiteCreateZone.jsx";
import SiteRemoteForm from "./design/sites/SiteRemoteForm.jsx";
import MultipleSelect from "./design/components/MultipleSelect.jsx";
import AddonForm from "./design/sites/AddonForm.jsx";
import PubMaticWeb from "./design/pubmatic/PubMaticWeb.jsx";
import PubMaticApp from "./design/pubmatic/PubMaticApp.jsx";
import PubMaticCtv from "./design/pubmatic/PubMaticCtv.jsx";
import CreateTag from "./design/pubmatic/createtag/CreateTag.jsx";
import CreateTag2 from "./design/pubmatic/createtag/CreateTag2.jsx";
import FirstForm from "./design/createcampaign/FirstForm.jsx";
import SecondForm from "./design/createcampaign/SecondForm.jsx";
import ThirdForm from "./design/createcampaign/ThirdForm.jsx";
import ForthForm from "./design/createcampaign/ForthForm.jsx";
import FiveFormTable from "./design/FiveTableForm/FiveFormTable.jsx";
import ExcludedCategoriesForm from "./design/FiveTableForm/ExcludedCategoriesForm.jsx";
import IpList from "./design/FiveTableForm/IpList.jsx";
import NewExtendedUserList from "./design/FiveTableForm/NewExtendedUserList.jsx";
import CreateAppBundleList from "./design/FiveTableForm/CreateAppBundleList.jsx";
import MediaPlannerFilter from "./design/mediaplanner/MediaPlannerFilter.jsx";
import GamTable from "./design/gamtable/GamTable.jsx";
import EditCampaign from "./design/editcampaign/EditCampaign.jsx";
import MediaPlannerListing from "./design/mediaplanner/MediaPlannerListing.jsx";
import FifthForm from "./design/createcampaign/FifthForm.jsx";
import CreateAdvertiser from "./design/createadvertiser/CreateAdvertiser.jsx";


function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>

        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        {/* <Route path="/register" element={<Register />} /> */}
        <Route path="/onboarding" element={<Onboarding />} />

        <Route path="/dashboard" element={<Dashboard />} />
        {/* <Route path="/zoneCreate" element={<ZoneCreate />} loading /> */}
        <Route path="/publisherList" element={<PublisherListing />} />
        <Route path="/zoneList" element={<ZoneListing />} />
        <Route path="/reporting" element={<Reporting />} />
        {/* <Route path="/savedReports" element={<SavedReports />} /> */}
        <Route path="/adsTxt" element={<AdTxtUpload />} />
        <Route path="/profile" element={<MyProfile />} />
        <Route path="/domainsMediaPlanner" element={<MediaPlanner />} />
        <Route path="/ctvMediaPlanner" element={<CTVMediaPlanner />} />
        {/* <Route path="/publisherDomain" element={<PublisherDomainListing />} /> */}
        <Route path="/userList" element={<AdminUserList />} />
        <Route path="/tagHistory" element={<AdminTagList />} />
        <Route path="/domainHistory" element={<AdminDomainList />} />
        <Route path="/ctvCsvHistory" element={<AdminCtvCsvUploadList />} />
        <Route path="/adcodesHistory" element={<AdminCheckAdcodesList />} />
        <Route path="/gamAutomation" element={<GamAutomationList />} />
        <Route path="/freewheel" element={<SiteListingFreewheel />} />
        <Route path="/pubmatic" element={<SiteListingPubmatic />} />
        <Route path="/remoteFeedList" element={<RemoteFeedListing />} />
        <Route path="/advertiser" element={<AdvertiserListing />} />
        <Route path="/campaignGam" element={<CampaignListGam />} />
        <Route path="*" element={<NoPageComponent />} />

        {/* ////////////////////////////////////////////////////////Listing Gam Demand //////////////////////////////////////////////////////////////////// */}
        <Route path="/appBundleListGam" element={<AppBundleListing />} />
        <Route path="/ipListGam" element={<IpListing />} />
        <Route path="/excludedCategoryListGam" element={<CategoryListing />} />
        <Route path="/extendedUserListGam" element={<ExtendedUserListing />} />



        {/* //////////////////////////////////////////////////////// UI Routes //////////////////////////////////////////////////////////////////////////// */}

        {/* Ui Routs */}

        
        {/* <Route path="/login-components" element={<LoginComponents />} />
        <Route path="/login-ui" element={<LoginUI />} />
        <Route path="/signup-ui" element={<SignupUi />} />
        <Route path="/otp-ui" element={<OtpUi />} />
        <Route path="/onboarding-ui" element={<OnboardingUi />} />
        <Route path="/onboarding-form-ui" element={<OnboardingFormUi />} />
        <Route path="/onboarding-message" element={<OnboardingMessageUi />} />
        <Route path="/publishers-listing-ui" element={<PubslishersListingUi />} />
        <Route path="/onboarding-components" element={<OnboardingComponents />} />
        <Route path="/gam-ui" element={<GamUi />} />
        <Route path="/ads-txt-ui" element={<AdsTxt />} />
        <Route path="/loader" element={<LoaderDesign />} />
        <Route path="/import-ui" element={<ImportUi />} />
        <Route path="/import-zone-ui" element={<ImportZoneUi />} />
        <Route path="/create-zone-ui" element={<CreateZoneUi />} />
        <Route path="/zone-listing-ui" element={<ZoneListingUi />} />
        <Route path="/components" element={<Components />} />
        <Route path="/sites-forms" element={<SitesForm />} />
        <Route path="/site-create-form" element={<SiteCreateZone />} />
        <Route path="/site-remote-form" element={<SiteRemoteForm />} />
        <Route path="/MultipleSelect" element={<MultipleSelect />} />
        <Route path="/site-create-form" element={<SiteCreateZone />} />
        <Route path="/pubmatic-web-form" element={<PubMaticWeb />} />
        <Route path="/pubmatic-app-form" element={<PubMaticApp />} />
        <Route path="/pubmatic-ctv-form" element={<PubMaticCtv />} />
        <Route path="/MultipleSelect" element={<MultipleSelect />} />
        <Route path="/create-tag-form" element={<CreateTag />} />
        <Route path="/create-tag-form2" element={<CreateTag2 />} />
        <Route path="/addon-form" element={<AddonForm/>}/>
        <Route path="/MultipleSelect" element={<MultipleSelect />} />
        <Route path="/sites-table" element={<SitesTable />} />
        <Route path="/components" element={<Components />} />
        <Route path="/addon-form" element={<AddonForm />} />
        <Route path="/second-form" element={<SecondForm />} />
        <Route path="/third-form" element={<ThirdForm />} />
        <Route path="/forth-form" element={<ForthForm />} />
        <Route path="/five-form-table" element={<FiveFormTable />} />
        <Route path="/ExcludedCategoriesForm" element={<ExcludedCategoriesForm />} />
        <Route path="/IpList" element={<IpList />} />
        <Route path="/NewExtendedUserList" element={<NewExtendedUserList />} />
        <Route path="/CreateAppBundleList" element={<CreateAppBundleList />} />
        <Route path="/media-filter" element={<MediaPlannerFilter />} />
        <Route path="/gem-table" element={<GemTable />} />
        <Route path="/forth-form" element={<ForthForm />} />
        <Route path="/fifth-form" element={<FifthForm />} />
        <Route path="/first-form" element={<FirstForm />} />
        <Route path="/edit-campaign" element={<EditCampaign />} />
        <Route path="/media-listing" element={<MediaPlannerListing />} />
        <Route path="/create-advertiser" element={<CreateAdvertiser />} /> */}


      </Routes>
    </BrowserRouter>
  );
}

export default App; 